import React, { useState } from 'react';
import { useDocument } from '../../Pages/SpreadsheetContainer/documentInfoContex';
import Header from '../Header/Header';
import { SpreadsheetContainerRd } from '../../Pages/SpreadsheetContainer/SpreadsheetContainerRd';
import { SpreadsheetContainer } from '../../Pages/SpreadsheetContainer/SpreadsheetContainer';
import DocumentDataConflictModal from '../ConflictModal';
import OfflineStatus from '../OfflineStatus/OfflineStatus';

const MainLayout = () => {

    const { isReadOnly, isConflictModalVisible, setIsConflictModalVisible, conflictPreviewVerion } = useDocument();
    const [contentLoading, setContentLoading] = useState(true);

    return (
        <>
            {isReadOnly ? (
                <>
                    {!conflictPreviewVerion && <Header fileDisplay={false} />}
                    <OfflineStatus />
                    <SpreadsheetContainerRd
                        contentLoading={contentLoading}
                        setContentLoading={setContentLoading}
                    />
                </>
            ) : (
                <>
                    {!contentLoading && <Header fileDisplay={true} />}
                    {!contentLoading && <OfflineStatus />}
                    <SpreadsheetContainer
                        contentLoading={contentLoading}
                        setContentLoading={setContentLoading}
                    />
                    <DocumentDataConflictModal
                        isConflictModalVisible={isConflictModalVisible}
                        setIsConflictModalVisible={setIsConflictModalVisible}
                    />
                </>
            )}

        </>
    )
}

export default MainLayout;